import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form'
import styled from 'styled-components'

import { WalletAddress } from '@root/entities/wallet'
import { InputChips } from '@root/shared/ui-kit/inputs/input-chip'

import { reatomEditTrackingWalletForm } from '../../atoms/reatom-edit-tracking-wallet-form'

import type { TrackingWallet } from '@root/entities/wallet-tracking'
import type { DialogControlProps } from '@root/shared/ui-kit'

type TrackingWalletTagsCellProps = {
  wallet: TrackingWallet.TrackingWallet
} & DialogControlProps

type Values = {
  tags: Array<string> | undefined
}

export const TrackingWalletTagsCell: React.FC<TrackingWalletTagsCellProps> = ({
  wallet,
}) => {
  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomEditTrackingWalletForm({
        walletAddress: WalletAddress(wallet.walletAddress),
      }),
    [wallet.walletAddress],
  )
  const [requestState] = useAtom(model)
  const execute = useAction(model.execute)

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: {
      tags: wallet.tags,
    },
    mode: 'all',
  })

  const handleSubmitInternal = handleSubmit((data) => {
    execute({ tags: data.tags })
  })

  return (
    <Root>
      <Form onSubmit={handleSubmitInternal}>
        <Controller
          control={control}
          name="tags"
          rules={{ required: false }}
          render={({ field }) => (
            <Input
              {...field}
              addOnBlur
              fullWidth
              hideClearAll
              disableEdition={requestState.loading}
              onChange={(...args) => {
                field.onChange(...args)
                handleSubmitInternal()
              }}
              placeholder={''}
              unique
              variant="outlined"
              size="small"
            />
          )}
        />
      </Form>
    </Root>
  )
}
const Root = styled.div`
  width: 100%;
`

const Form = styled.form`
  width: 100%;
`
const Input = styled(InputChips)`
  --input-chips-padding: 1px;
  --input-chips-border-radius: 4px;
`
